import React from 'react';
import request from "../../utils/agent";
import { convertCData, toTitleCase } from "../../utils";
import Loader from 'components/Loader';
import ReactTable from "react-table";
import { BrowserRouter as Router, Route, Link, Switch } from "react-router-dom";
import { Redirect } from "react-router-dom";
import { confirmAlert } from 'react-confirm-alert'
import './AdminReports.scss';

export default class AdminReports extends React.Component {
  constructor(props) {
    super(props);

      this.state = {
          users: [],
          loaded: false,
          expanded: false,
          search:'',
          searchAll:'',
          searchAdmin: '',
          clicked: false,
          userUpdated: false,
          deleteId : null,
          viewId: '',
          updatedViewId: false,
          allUsersSelected: [],
          allSelectAll: false,
      };
  }
    componentDidMount() {
        this.getAllUsers();
    }



    componentDidUpdate() {
        if(this.state.userUpdated === true) {
            this.getAllUsers();
            this.setState({
                userUpdated: false,
                clicked: false,
                loaded: true,
            });

        }
    }

    getAllUsers = () => {
        request.get("/api/admin/users_denorm").then(resp => {
            let users = convertCData(resp.body.users_denorm);
            this.setState({users, loaded: true}, () => {
                this.loadTables();
            });
            window.users = users;
        });
    }

    loadTables = () => {
        window.$(document).ready(function() {
            console.log('ready');
            window.$pending_table = $("#pending-table").DataTable( {
                columnDefs: [ {
                    targets: [ 1, 2, 3, 4 ],
                    render: function ( data, type, row ) {
                        return data.length > 28 ? data.substr( 0, 28 ) + '...' : data;
                    }
                }],
                "order": [[ 1, "asc" ]],
                "initComplete": this.hiddenColsFix
            });
        });
    }

    bypassTraining = (id) => {
        return new Promise(resolve => {
            request.post(`/api/training/${id}`)
                .send({
                    user_id: id, // This is my current ID, hard coded.
                    success: true, //Enforce boolean
                    percent: 100,
                    course_id: 1 // Unsure how we would figure this out
                })
                .then(resp => {
                    let users = this.state.users.map(u => {
                        if(u.id === id) {
                            if(!u.trainings) {
                                u.trainings = [];
                            }
                            u.trainings = [{"course":{"name":"Module 1: The Noon Lighting System"},"success":true,"percent":100}];
                            u.training_percent = 100;
                        }
                        return u;
                    });
                    this.setState({
                        // userUpdated: true,
                        // loaded: false,
                        users
                    }, () => {
                        resolve();
                    });
                    // Original code has it just to back to the dashboard
                    if (resp && resp.status === 200) {
                        //Go back to main page
                    } else {
                        // Have them re-take the test?
                    }
                })
                .catch(err => {
                    // We could retry it or just let the user know something went wrong
                });
        })
    }


    handleTrBypassClick(e, row, id) {
        e.preventDefault();
        this.setState({
            clicked: true,
        });
        this.bypassTraining(id);
    }


    approveUser(id) {
        return new Promise((resolve, reject) => {
            request.post(`/api/user/${id}/approved`)
                .send({
                    id: id,
                    status: 'approved'
                })
                .then(resp => {
                    resolve(resp.body);
                    //console.log('Call done', resp.body);
                    this.setState({
                        userUpdated: true,
                    })
                })
                .catch(err => {
                    console.error('error', err);
                })

        })
    }

    handleApproveClick(e, row, id) {
        e.preventDefault();
        this.setState({
            clicked: true,
            loaded: false,
        });

        this.approveUser(id);
    }

    denyUser(id) {
        return new Promise((resolve, reject) => {
            request.post(`/api/user/${id}/denied`)
                .send({
                    id: id,
                    status: 'denied'
                })
                .then(resp => {
                    resolve(resp.body);
                    //console.log('Call done', resp.body);
                    this.setState({
                        userUpdated: true,
                    })
                })
                .catch(err => {
                    console.error('error', err);
                })

        })
    }


    handleDenyClick(e, row, id) {
        e.preventDefault();
        this.setState({
            clicked: true,
        });

        this.denyUser(id);
    }

    deleteUser = (id) => {
        return new Promise((resolve, reject) => {
            request.post(`/api/deleteuser/${id}`)
                .send({
                    id: id,
                })
                .then(resp => {
                    resolve(resp.body);
                    //console.log('Call done', resp.body);
                    let users = this.state.users.filter(u => u.id !== id);
                    this.setState({
                        // userUpdated: true,
                        users
                    }, () => {
                        resolve();
                    });
                })
                .catch(err => {
                    console.error('error', err);
                })

        });
    }

    showAlert(e, row, id) {
        e.preventDefault();
        this.setState({
            deleteId: id,
            clicked: true,
        });

        confirmAlert({
            customUI: ({ onClose }) => {
                return (
                    <div className='custom-ui-dialog'>
                        <h3>Are you sure you want to delete this user?</h3>
                        <br/>
                        <button
                            className="btn btn-default btn-primary btn-view-users cancel"
                            onClick={onClose}>Cancel</button>
                        <button
                            className="btn btn-default btn-primary btn-view-users delete"
                            onClick={() => {
                                this.handleDeleteUser()
                                onClose()
                            }}>Confirm Delete</button>
                    </div>
                )
            }
        })
    };


    handleDeleteUser() {
        //console.log('handle id',this.state.deleteId);
        this.deleteUser(this.state.deleteId);
    }


    toggleRow = (id, group) => {
        let index = this.state[group].indexOf(id)
        // Add to selected list
        if(index === -1) {
            this.setState({[group]: [...this.state[group], id]});
        } else {
            let updatedArray = [...this.state[group]];
            updatedArray.splice(index, 1)
            this.setState({
                [group]: updatedArray,
                recentSelectAll: false,
                allSelectAll: false
            });
        }
    }

    toggleAll = (ref, group, key) => {
        let table = this.refs[ref].getResolvedState();
        let data = table.sortedData;
        let start = table.page * table.pageSize;
        let end = table.pageSize + start;
        let selectedData = data.slice(start, end);
        if(this.state[key]) {
            this.setState({
                [key]: !this.state[key],
                [group]: []
            });
        } else {
            this.setState({
                [key]: !this.state[key],
                [group]: selectedData.map(u => u.id)
            });
        }
    }

    bulkActionAlert = (msg, action) => {
        confirmAlert({
            customUI: ({ onClose }) => {
                return (
                    <div className='custom-ui-dialog'>
                        <h3>Are you sure you want to {msg.toLowerCase()} these users?</h3>
                        <br/>
                        <button
                            className="btn btn-default btn-primary btn-view-users cancel"
                            onClick={onClose}>Cancel</button>
                        <button
                            className="btn btn-default btn-primary btn-view-users delete"
                            onClick={() => {
                                this.bulkAction(action)
                                onClose()
                            }}>Confirm {msg}</button>
                    </div>
                )
            }
        })
    }

    bulkAction = async (action) => {
        let userIds = [];
        let func = null;
        switch(action) {
            case 'bypassTraining':
                userIds = this.state.allUsersSelected;
                func = this.bypassTraining;
                break;
            case 'deleteUsers':
                userIds = this.state.allUsersSelected;
                func = this.deleteUser;
                break;
        }

        for(let id of userIds) {
            await func.call(null, id);
        }

        // Reset state afterwards
        this.setState({
            allUsersSelected: [],
            allSelectAll: false
        })
    }

    exportsAllUsers() {
        request.get('/admin/export/users')
            .then(resp => {
                var blob = new Blob([resp.text], { type: 'text/csv;charset=utf-8;' });
                var link = document.createElement("a");
                var url = URL.createObjectURL(blob);
                link.setAttribute("href", url);
                link.setAttribute("download", 'Noon Users.csv');
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            })
    }


  render() {

      //console.log('rep users', this.state.users);
      //console.log('loaded', this.state.loaded);
      //console.log('clicked', this.state.clicked);

      let allUsers = this.state.users.filter(user => user.role_name && user.role_name != 'pOwner');
      //console.log('all users', allUsers);

      if(this.state.searchAll) {
          allUsers = allUsers.filter(row => {
              return row.cdata.first_name.includes(this.state.searchAll) || row.email.includes(this.state.searchAll) || row.role_name.includes(this.state.searchAll)
          })
      }

      const pageOpts = [10, 25, 50, 100];

      const allUsersColumns = [
          {
              id: "checkbox",
              accessor: "",
              Cell: ({ original }) => {
                  return (
                      <input
                          type="checkbox"
                          className="checkbox"
                          checked={this.state.allUsersSelected.indexOf(original.id) > -1}
                          onChange={() => this.toggleRow(original.id, 'allUsersSelected')}
                      />
                  );
              },
              Header: x => {
                  return (
                      <input
                          type="checkbox"
                          className="checkbox"
                          checked={this.state.allSelectAll === true}
                          onChange={() => this.toggleAll('allUsersTable', 'allUsersSelected', 'allSelectAll')}
                      />
                  );
              },
              sortable: false,
              width: 55
          },
          {
              Header: 'Id',
              id: 'id',
              accessor: user => user.id,
              className: 'react--tb--styles',
              show: false
          },
          {
              Header: 'Name',
              id: 'name',
              accessor: user => `${user.cdata.first_name} ${user.cdata.last_name}`,
              className: 'react--tb--styles',
          },
          {
              Header: 'Email',
              id: 'email',
              accessor: user => user.email,
              className: 'react--tb--styles',
          },
          {
              Header: 'Business',
              accessor: 'company_name',
              className: 'react--tb--styles',
          },
          {
              Header: 'Location',
              accessor: 'cdata.business_city',
              className: 'react--tb--styles',
          },
          {
              Header: 'Status',
              className: 'action--tb--styles',
              id: 'status',
              width: 60,
              accessor: user => user.cdata.status,
              Cell: row => (
                  <span
                      className='tb-status-circle'
                      style={{
                          background: row.value === 'approved'? '#39B54A':
                              row.value === 'pending' ? '#F7941E' :
                                  '#bf1e2e',
                      }}>
                  </span>
              )
          },
          {
              Header: 'Training Status',
              className: 'action--tb--styles',
              id: 'training_status',
              width: 60,
              accessor: user => user.training_percent ? user.training_percent : 0,
              Cell: row => (
                  <span
                      className='tb-status-circle'
                      style={{
                          background: row.value === 0 ? '#F7941E' :
                              (row.value > 0 && row.value < 80) ? '#bf1e2e' :
                                  '#39B54A',
                      }}>
                  </span>
              )
          },
          {
              Header: 'Role',
              id: 'role',
              accessor: user => user.role_name,
              className: 'react--tb--styles',

          },
          {
              Header: 'Submission Date',
              id: 'created_at',
              accessor: user => user.created_at,
              className: 'react--tb--styles',
              Cell: row => (
                  <span>
                      {new Date(row.value).toLocaleDateString()}
                  </span>
              )
          },
          {
              Header: 'View',
              className: 'action--tb--styles',
              width: 60,
              Cell:({row, original}) => {
                  return (
                      <Link to={`/admin/user/${original.id}`} className='view-btn-icon'>
                          <i className='ion-edit'></i>
                      </Link>
                  )
              }
          },
          {
              Header: 'Delete',
              className: 'action--tb--styles',
              width: 60,
              Cell: ({row, original}) => {
                  return (
                      <button id="delete" className='delete-btn-icon' onClick={(e) => this.showAlert(e, row, original.id)}>
                          <i className='ion-android-delete'></i>
                      </button>)
              }
          },
          {
              Header: 'Bypass Training',
              className: 'action--tb--styles',
              width: 60,
              Cell: ({row, original}) => {
                  return (
                      <button id="bypass" className='approve-btn-icon' onClick={(e) => this.handleTrBypassClick(e, row, original.id)}>
                          <i className='ion-checkmark-circled'></i>
                      </button>)
              }
          },

      ];


    return (
        <section className="posrel">
            <div className="col-xs-3 headerBtns">
                <a onClick={this.exportsAllUsers} className="btn btn-default btn-primary csv-button"><i className="icon-downloads"></i>Export All Users CSV</a>
            </div>
            <h1 className='admin--reports--title'>User Reporting</h1>
            {this.state.loaded === true ?
                <div>
                    <div className='users-table-hoalder'>
                        <h4 className='table-title'>Users</h4>
                        <div className='tb-search-holder'>
                            <div className='search--cont'>
                                Search: <input
                                className='tb-search-input'
                                value={this.state.searchAll}
                                onChange={e => this.setState({searchAll: e.target.value})}
                            />
                                {this.state.allUsersSelected.length > 0 && <div className='bulk-input-group'>
                                    <button className='btn btn-sm btn-success'onClick={() => this.bulkAction('bypassTraining')}>Bypass Training</button>
                                    <button className='btn btn-sm btn-danger'onClick={() => this.bulkActionAlert('Delete', 'deleteUsers')}>Delete Users</button>
                                </div>}
                            </div>
                            <ReactTable
                                ref="allUsersTable"
                                data={allUsers}
                                resolveData={allUsers => allUsers.map(row => row)}
                                defaultPageSize={10}
                                columns={allUsersColumns}
                                pageSizeOptions={pageOpts}
                            />
                        </div>
                    </div>
                </div>:
                <div className='loader--holder'>
                    <Loader/>
                </div>
            }
        </section>
    )
  }
}


// WEBPACK FOOTER //
// ./src/routes/AdminReports/index.js